import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var BlogTag = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment tags on PostTag {\n    id\n    title\n    slug\n  }\n"])));
export default BlogTag;